export class CreatePermisoRequest {
  public descripcion?: string
  public token?: string
  public id_CasoUso?: number
  public id_Rol?: number
}
